import React from 'react';

import "./Spinner.css"

const Spinner = () => {
    return (
        <div className='control_height'>
            <div className='Spinner'>
            
            </div>
        </div>
        
    );
};

export default Spinner;